import { AType, summon, tagged } from "@silversea-ssc/functional-support"
import { PriceResponseV2, SuitePayment } from "../price"
import { SuiteNumber } from "../suite-number"
import { CheckoutFlowType } from "../checkout-flow-type"

export const EmptyCheckoutStatusResponse = summon((F) =>
    F.interface({ type: F.stringLiteral("empty") }, "EmptyCheckoutStatusResponse"),
)
export type EmptyCheckoutStatusResponse = AType<typeof EmptyCheckoutStatusResponse>

export const ValidatedCheckoutStatusResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("validated"),
            suitePayment: SuitePayment(F),
            validatedPrice: PriceResponseV2(F),
            suiteNumber: SuiteNumber(F),
            flowType: CheckoutFlowType(F),
        },
        "ValidatedCheckoutStatusResponse",
    ),
)
export type ValidatedCheckoutStatusResponse = AType<typeof ValidatedCheckoutStatusResponse>

export const StartedCheckoutStatusResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("started"),
            bookingNumber: F.string(),
            suitePayment: SuitePayment(F),
            validatedPrice: PriceResponseV2(F),
            suiteNumber: SuiteNumber(F),
            flowType: CheckoutFlowType(F),
            expiration: F.date(),
        },
        "StartedCheckoutStatusResponse",
    ),
)
export type StartedCheckoutStatusResponse = AType<typeof StartedCheckoutStatusResponse>

export const CompletedCheckoutStatusResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("completed"),
            bookingNumber: F.string(),
            suitePayment: SuitePayment(F),
            validatedPrice: PriceResponseV2(F),
            flowType: CheckoutFlowType(F),
        },
        "CompletedCheckoutStatusResponse",
    ),
)
export type CompletedCheckoutStatusResponse = AType<typeof CompletedCheckoutStatusResponse>

const ErrorCode = summon((F) => F.keysOf({ suiteNoMoreAvailable: null, other: null, cancelled: null }))
export const FailedCheckoutStatusResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("failed"),
            errorCode: ErrorCode(F),
            flowType: CheckoutFlowType(F),
        },
        "FailedCheckoutStatusResponse",
    ),
)
export type FailedCheckoutStatusResponse = AType<typeof FailedCheckoutStatusResponse>

export const CheckoutStatusResponse = tagged("type")({
    empty: EmptyCheckoutStatusResponse,
    validated: ValidatedCheckoutStatusResponse,
    started: StartedCheckoutStatusResponse,
    completed: CompletedCheckoutStatusResponse,
    failed: FailedCheckoutStatusResponse,
})
export type CheckoutStatusResponse = AType<typeof CheckoutStatusResponse>
